import { z } from 'zod';

export const useEstablishmentAddValidation = () => {
	const establishmentAddSchema = z.object({
		id: z.number().optional(),
		name: z.string().trim().min(1),
	});

	return { establishmentAddSchema };
};
export type EstablishmentAddForm = z.infer<ReturnType<typeof useEstablishmentAddValidation>['establishmentAddSchema']>;
